import { styled } from '@mui/material/styles';

export const Container = styled('div')`
  margin: 100px;
`;
